import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {ITablelistExecute} from "../../interfaces";
import {Observable} from "rxjs";
import {WorklistService} from "../../services/worklist.service";
import {get} from 'lodash';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';

@Component({
  selector: 'ispm-worklist-execute',
  templateUrl: './worklist-execute.component.html',
  styleUrls: ['./worklist-execute.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorklistExecuteComponent implements OnInit {

  @Input() rowData;
  @Input() currentUserId;
  @Input() practitionerType: string;
  @Input() executeActions: ITablelistExecute[];
  @Input() payload: any;

  public activeRow: Observable<string>;
  public enabled: boolean = false;
  private _isPerformer: boolean = false;
  private properties: any[] = [];
  private defaultCssClass: string = 'icon__execute';

  // TODO: remove unnecessary constructor parameters
  constructor(
    private workflowService: WorkflowService,
    private worklistService: WorklistService) {

    this.activeRow = this.worklistService.getActiveRowObservable();
  }

  ngOnInit() {
    // get if current user has the following permissions:
    this.practitionerType = this.practitionerType ? this.practitionerType : 'performer';
    this._isPerformer = this.isPerformer(this.currentUserId);
    this.parseProperties();
    this.isEnabled();
  }

  private isEnabled() {
    this.enabled = this.executeActions.some(action => action.enableCondition(this, action));
  }

  public getClass() {
    return this.enabled ? get(this.payload, 'enabled.cssClass', this.defaultCssClass) : get(this.payload, 'disabled.cssClass', this.defaultCssClass);
  }

  public runActions($event: any) {
    $event.stopPropagation();
    if(this.enabled) {
      this.executeActions.forEach(action => action.action(this));
    }
  }

  private parseProperties() {
    // parse payload (from worklist template item and executeActions
    if (!!this.payload) {
      Object.getOwnPropertyNames(this.payload).forEach(property => {
        this.properties.push(get(this.payload, property));
      });
    }
  }

  private isPerformer(userId: string): boolean {
    var self = this;
    return this.rowData.references && this.rowData.references.find((ref) => {
      if (ref.key === 'practitioner') {
        const refVal = JSON.parse(ref.value);
        return (refVal.practType === self.practitionerType && refVal.practId === userId);
      }
      return false;
    });
  }

}
